/* eslint-disable  */
class UbuntuSliderComponent extends SliderComponent {
  constructor() {
    super()
  }

  onButtonClick (event) {
    event.preventDefault()
    const moveAmount = this.sliderItemOffset

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + moveAmount
        : this.slider.scrollLeft - moveAmount

    this.setSlidePosition(this.slideScrollPosition)
  }
}

try {
  customElements.define('ubuntu-slider-component', UbuntuSliderComponent)
} catch (error) {
  console.log('Failed to define UbuntuSliderComponent:', error)
}
